<template>
  <div class="room">
    <iframe
      width="100%"
      height="100%"
      src="https://o2vr.net/upload/dingzhou/225/tour.html"
      v-if="id == 0"
    >
    </iframe>
    <iframe
      width="100%"
      height="100%"
      src="https://o2vr.net/upload/dingzhou/151/tour.html"
      v-if="id == 1"
    >
    </iframe>

    <iframe
      width="100%"
      height="100%"
      src="https://o2vr.net/upload/dingzhou/129/tour.html"
      v-if="id == 2"
    >
    </iframe>
    <Back />
  </div>
</template>

<script>
import Back from "../components/back.vue";
export default {
  data() {
    return {
      id: "",
    };
  },
  components: {
    Back,
  },
  created() {
    this.id = this.$route.query.id;
  },
};
</script>

<style lang="scss" scoped>
.room {
  width: 100%;
  height: 100%;
}
</style>
